import React from 'react';
import LiveTimConsultList from '../../../components/consult/list/livetim-list';

export default () => {
  return <LiveTimConsultList/>
}